// extracted by mini-css-extract-plugin
module.exports = {"footerSitemapLinks":"Footer_footerSitemapLinks__0knSt","footer":"Footer_footer__OYoYH"};